var render, staticRenderFns
import script from "./PortalIcon.vue?vue&type=script&lang=js&"
export * from "./PortalIcon.vue?vue&type=script&lang=js&"
import style0 from "./PortalIcon.vue?vue&type=style&index=0&id=29ff1146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff1146",
  null
  
)

export default component.exports